<template>
    <div class="all">
        <!-- 筛选 -->
        <analysisHeader ref="child"></analysisHeader>
        <div class="echart-grid clearfix">
            <!-- 数据汇总 -->
            <div class="grid-father">
                <div class="grid">
                    <div class="grid-header clearfix">
                        <h2 class="title fl">数据汇总</h2>
						<div class="corm fr clearfix">
							<span class="element" :class="allDataType === 'solid' ? 'curr' : ''" @click="allDataType = 'solid';">趋势图</span>
						    <span class="element" :class="allDataType === 'dashes' ? 'curr' : ''" @click="allDataType = 'dashes'" v-show="lineChartData.dashes">预测图</span>
                            <span class="element" :class="allDataType === 'predict' ? 'curr' : ''" @click="allDataType = 'predict'">7天预测图</span>
						</div>
                    </div>
                    <div class="data-load" v-if="load.lineChartData"><img src="/static/images/loading1.gif" class="img"/><span class="text">获取数据中...</span></div>
                    <div class="grid-body mt15" v-if="allDataType!=='predict'">
                        <div class="firle clearfix" v-if="!load.lineChartData&&allDataType!=='predict'">
                            <div class="tion fl">
                                <strong class="db fs28">{{informatinCount}}</strong>
                                <span class="db">信息总数</span>
                            </div>
                        </div>
                        <div class="echart-warp h260">
                            <lineChart id="lineEchart" :itemHeight='4'  :dataArray="lineChartData[allDataType]" :dottedLine="true" v-if="lineChartData !='' && !load.lineChartData" gridBot="55"></lineChart>   
                        </div>                     
                    </div>  
                    <div class="grid-body mt15" v-else>
                        <div class="echart-warp h260">
                            <lineChart id="lineForecastEchart" :itemHeight='4'  :dottedLine="true" :dataArray="lineForecastData" v-if="lineForecastData !='' && !load.lineForecastData" gridBot="55"></lineChart>
                        </div>                    
                    </div>
                </div>
            </div>
            <!-- 热门文章 -->
            <div class="grid-father">
                <div class="grid">
                    <div class="grid-header clearfix">
                        <h2 class="title fl">热点微博</h2>
                        <div class="corm fr clearfix">
                            <span class="element" :class="weiboType == 1 ? 'curr' : ''" @click="selectWeiboType(1);">转发</span>
                            <span class="element" :class="weiboType == 2 ? 'curr' : ''" @click="selectWeiboType(2);">评论</span>
                            <span class="element" :class="weiboType == 3 ? 'curr' : ''" @click="selectWeiboType(3);">点赞</span>
                        </div>
                    </div>
                    <div class="grid-body mt15">
                        <div class="data-load" v-if="load.hotWeiboList"><img src="/static/images/loading1.gif" class="img"/><span class="text">获取数据中...</span></div>
                        <div class="no-data no-datas" v-if="noData.hotWeiboList && !load.hotWeiboList"><span class="text">暂无数据</span></div>
                        <ul class="news" v-if="!load.hotWeiboList">
                            <li v-for="(item,index) in hotWeiboList" :key="index">
                                <router-link class="title color-3d3d4c ovhidden fl" target="_blank" :title="item.newsTitle" :to="{path:'/detail',query: {data:item.newsId+','+item.newsSimHash+','+startDate+','+endDate}}">{{item.newsTitle}}">{{item.newsTitle}}</router-link>
                                <!-- <span class="type fl">{{item.typeName}}</span> newsId newsReadCount-->
                                <span class="number fr" v-if="weiboType === 1"><i class="icons forward-icon"></i>{{item.newsRepostsCount}}</span>
                                <span class="number fr" v-if="weiboType === 2"><i class="icons comment-icon"></i>{{item.newsCommentCount}}</span>
                                <span class="number fr" v-if="weiboType === 3"><i class="icons zan-icon"></i>{{item.newsLikeCount}}</span>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>

            <!-- 情绪走势 -->
			<div class="grid-father">
			    <div class="grid">
			        <div class="grid-header clearfix">
			            <h2 class="title fl">情绪走势</h2>
						<div class="corm fr clearfix">
							<span class="element" :class="moodType === 'bar' ? 'curr' : ''" @click="moodType = 'bar'">占比图</span>
						    <span class="element" :class="moodType === 'line' ? 'curr' : ''" @click="moodType = 'line'">趋势图</span>
						</div>
			        </div>
			        <div class="grid-body mt15">
			            <div class="data-load" v-if="load.moodLineData"><img src="/static/images/loading1.gif" class="img"/><span class="text">获取数据中...</span></div>
			            <div class="echart-warp h305" v-if="!load.moodLineData">
							<lineChart class="tl0" id="moodBar" :percentage="moodType === 'bar' ? true : false" :dataArray="moodType === 'bar' ? moodBarData : moodLineData" v-if="moodLineData != ''"></lineChart>
			                <!-- <lineChart class="tl0" id="moodLine" :class="moodType === 'line' ? '' : 'pr-op'" :dataArray="moodLineData" v-if="moodLineData != ''"></lineChart> -->
			            </div>
			        </div>
			    </div>
			</div>

            <!-- 7天预测 -->
			<div class="grid-father" v-show="false">
			    <div class="grid">
			        <div class="grid-header clearfix">
			            <h2 class="title fl">7天预测<i class="icon-sign sign-red ml5">Beta</i></h2>
			        </div>
			        <div class="grid-body mt15">
			            <div class="data-load" v-if="load.lineForecastData"><img src="/static/images/loading1.gif" class="img"/><span class="text">获取数据中...</span></div>
			            <div class="echart-warp h305" v-if="!load.lineForecastData">
							<lineChart id="lineForecastEchart" :dottedLine="true" :dataArray="lineForecastData" v-if="lineForecastData !='' && !load.lineForecastData" gridBot="55"></lineChart>
			            </div>
			        </div>
			    </div>
			</div>

            <!-- 知云图 -->
			<div class="grid-father" v-show="false">
			    <div class="grid">
			        <div class="grid-header clearfix">
			            <h2 class="title">知云图<i class="icon-sign sign-red ml5">Beta</i><a href="javascript:void(0);" @click="openZhiyuntu" class="icons eye-icon fr" v-show="!load.knowledge && !noData.knowledge" title=""></a></h2>
			        </div>
			        <div class="grid-body mt15">
			            <div class="data-load" v-if="load.knowledge"><img src="/static/images/loading1.gif" class="img"/><span class="text">获取数据中...</span></div>
			            <div class="no-data no-datas" v-if="noData.knowledge && !load.knowledge"><span class="text">暂无数据</span></div>
                        <div class="echart-warp h305" v-if="!load.knowledge && !noData.knowledge">
							<d3Chart id="d3Svgs" :dataArry="dsCharts" @nodeClick="openZhiyuntu" :crieSize="60" lineColor="#000" textPosition="inside" v-if="dsCharts != ''"></d3chart>
			            </div>
			        </div>
			    </div>
			</div>
			
			<!-- 情绪分布 -->
			<div class="grid-father">
			    <div class="grid">
			        <div class="grid-header clearfix">
			            <h2 class="title fl">情绪分布</h2>
			        </div>
			        <div class="grid-body mt15">
			            <div class="data-load" v-if="load.moodLineData"><img src="/static/images/loading1.gif" class="img"/><span class="text">获取数据中...</span></div>
			            <div class="echart-warp h305" v-if="!load.moodLineData">
			                <pieChart id="moodPie" :dataArray="moodPieData" :showLegend="false" :colorArr="moodPieColor" v-if="moodLineData != ''" jump="mood"></pieChart>
			                <!-- <lineChart id="moodLine" :dataArray="moodLineData" v-if="moodLineData != ''"></lineChart> -->
			            </div>
			        </div>
			    </div>
			</div>

            <!-- 情感属性 -->
            <div class="grid-father">
                <div class="grid">
                    <div class="grid-header clearfix">
                        <h2 class="title fl">情感属性</h2>
                        <div class="corm fr clearfix">
                            <span class="element" :class="tuType === 'pie' ? 'curr' : ''" @click="emotionEchartTab('pie');">饼状图</span>
                            <span class="element" :class="tuType === 'line' ? 'curr' : ''" @click="emotionEchartTab('line');">趋势图</span>
                        </div>
                    </div>
                    <div class="grid-body mt15">
                        <div class="data-load" v-if="load.emotionLineData"><img src="/static/images/loading1.gif" class="img"/><span class="text">获取数据中...</span></div>
                        <div class="echart-warp h305" v-if="!load.emotionLineData">
                            <pieChart id="pieEchart1" :dataArray="emotionPieData" :showLegend="false" :colorArr="pieColorArr" v-if="tuType === 'pie' && emotionPieData != ''" jump="emotion"></pieChart>
                            <lineChart id="emotionType" :dataArray="emotionLineData" v-if="tuType === 'line' && emotionLineData != ''"></lineChart>
                        </div>
                    </div>
                </div>
            </div>

            <!-- 活跃账号 -->
            <div class="grid-father">
                <div class="grid">
                    <div class="grid-header clearfix">
                        <h2 class="title fl">活跃账号</h2>
                    </div>
                    <div class="grid-body mt30">
                        <div class="data-load" v-if="load.activeMediaList"><img src="/static/images/loading1.gif" class="img"/><span class="text">获取数据中...</span></div>
                        <div class="no-data no-datas" v-if="noData.activeMediaList && !load.activeMediaList"><span class="text">暂无数据</span></div>
                        <ul class="strip-shape" v-if="!load.activeMediaList">
                            <li class="cp" v-for="(item,index) of activeMediaList" :key="index" @click="$refs.child.listJump('activeMedia',item.platformName);">
                                <div class="people clearfix fl">
                                   <img :src="item.accountAvatar == '' ? '/static/images/no_img.jpg' : item.accountAvatar" class="img fl" onerror="this.src='/static/images/no_img.jpg'"/>
                                   <span class="name ovhidden" :title="item.platforName">{{item.platformName}}</span>
                                </div>
                                <div class="number fr">
                                   <strong class="color-blue">{{item.newsTotal}}</strong> 篇
                                </div>
                                <div class="line-warp clearfix">
                                    <div class="line">
                                        <div class="in" :style='{width:""+item.percent+""}'></div>
                                    </div>
                                </div>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>

            <!-- 敏感信息报道账号 -->
            <div class="grid-father">
                <div class="grid">
                    <div class="grid-header  clearfix ">
                        <h2 class="title">敏感信息报道账号</h2>
                    </div>
                    <div class="grid-body mt15">
                        <div class="data-load" v-if="load.sensitiveMediaLiat"><img src="/static/images/loading1.gif" class="img"/><span class="text">获取数据中...</span></div>
                        <div class="no-data no-datas" v-if="noData.sensitiveMediaLiat && !load.sensitiveMediaLiat"><span class="text">暂无数据</span></div>
                        <ul class="news" v-if="!load.sensitiveMediaLiat">
                            <li class="cp" v-for="(item,index) of sensitiveMediaLiat" :key="index" @click="$refs.child.listJump('sensitiveMedia',item.platformName);">
                                <div class="people clearfix fl">
                                   <img :src="item.accountAvatar == '' ? '/static/images/no_img.jpg' : item.accountAvatar" class="img fl" onerror="this.src='/static/images/no_img.jpg'"/>
                                   <span class="name ovhidden" :title="item.platforName">{{item.platformName}}</span>
                                </div>
                                <span class="number fr"><strong class="color-blue">{{item.newsTotal}}</strong> 篇敏感文章</span>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>

            <!-- 影响力账号 -->
            <div class="grid-father">
                <div class="grid">
                    <div class="grid-header  clearfix ">
                        <h2 class="title">影响力账号</h2>
                    </div>
                    <div class="grid-body mt15">
                        <div class="data-load" v-if="load.influenceMediaLiat"><img src="/static/images/loading1.gif" class="img"/><span class="text">获取数据中...</span></div>
                        <div class="no-data no-datas" v-if="noData.influenceMediaLiat && !load.influenceMediaLiat"><span class="text">暂无数据</span></div>
                        <ul class="news" v-if="!load.influenceMediaLiat">
                            <li class="cp" v-for="(item,index) of influenceMediaLiat" :key="index" @click="$refs.child.listJump('influenceAccount',item.platformName);">
                                <div class="people clearfix fl">
                                   <img :src="item.accountAvatar == '' ? '/static/images/no_img.jpg' : item.accountAvatar" class="img fl" onerror="this.src='/static/images/no_img.jpg'"/>
                                   <span class="name ovhidden" :title="item.platforName">{{item.platformName}}</span>
                                </div>
                                <span class="number fr"><span class="tag btn-jbblue">BCI</span> {{item.wci}}</span>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>

            <!-- 账号认证 -->
            <div class="grid-father">
                <div class="grid">
                    <div class="grid-header clearfix">
                        <h2 class="title fl">账号认证</h2>
                    </div>
                    <div class="grid-body mt15">
                        <div class="echart-warp h310">
                            <div class="data-load" v-if="load.certifyAccount"><img src="/static/images/loading1.gif" class="img"/><span class="text">获取数据中...</span></div>
                            <div class="no-data no-datas" v-if="noData.certifyAccount && !load.certifyAccount"><span class="text">暂无数据</span></div>
                            <pieChart id="pieEchart3" :dataArray="certifyAccount" :showLegend="false" :colorArr="pieColorArr" v-if="certifyAccount != '' && !load.certifyAccount" jump="certify"></pieChart>
                        </div>
                    </div>
                </div>
            </div>

            <!-- WCI分布 -->
            <div class="grid-father">
                <div class="grid">
                    <div class="grid-header clearfix">
                        <h2 class="title fl">BCI分布</h2>
                    </div>
                    <div class="grid-body mt15">
                        <div class="echart-warp h310">
                            <div class="data-load" v-if="load.bciData"><img src="/static/images/loading1.gif" class="img"/><span class="text">获取数据中...</span></div>
                            <barChart id="barEchart" :dataArray="bciData" xAxisName="BCI" yAxisName="公号个数" v-if="bciData != '' && !load.bciData" jump="bci"></barChart>
                        </div>
                    </div>
                </div>
            </div>

            <!-- 文章类型 -->
            <div class="grid-father">
                <div class="grid">
                    <div class="grid-header clearfix">
                        <h2 class="title fl">文章类型</h2>
                        <div class="grid-info fl">
                            <i class="icons icons-question-circle"></i>
                            <p class="grid-tip">当前方案分析的所有文章的类型分布占比</p>
                        </div>
                    </div>
                    <div class="grid-body mt15">
                        <div class="echart-warp h310">
                            <div class="data-load" v-if="load.articlesTypeData"><img src="/static/images/loading1.gif" class="img"/><span class="text">获取数据中...</span></div>
                            <div class="no-data no-datas" v-if="noData.articlesTypeData && !load.articlesTypeData"><span class="text">暂无数据</span></div>
                            <pieChart id="pieEchart2" :dataArray="articlesTypeData" :showLegend="false" :colorArr="pieColorArr" v-if="articlesTypeData != '' && !load.articlesTypeData" jump="articleType"></pieChart>
                        </div>
                    </div>
                </div>
            </div>

            <!-- 热门主题词 -->
            <div class="grid-father">
                <div class="grid">
                    <div class="grid-header clearfix">
                        <h2 class="title fl">热门主题词</h2>
                        <div class="grid-info fl">
                            <i class="icons icons-question-circle"></i>
                            <p class="grid-tip">当前方案分析到的所有文章中提及频率最多的词语</p>
                        </div>
                        <div class="firle fr">
                            <button class="tion btn btn-jbblue" @click="shieldThemeWord();">屏蔽主题词</button>
                            <span class="tion drop-down">
                                <button class="btn btn-lightblue"><span class="text">词云图</span><i class="icons"></i></button>
                                <ul class="option">
                                    <li @click="hotThemeTab(0);">词云图</li>
                                    <li @click="hotThemeTab(1);">饼图</li>
                                    <li @click="hotThemeTab(2);">雷达图</li>
                                    <li @click="hotThemeTab(3);">热词走势</li>
                                    <li @click="hotThemeTab(9);">知云图</li>
                                </ul>
                            </span>
                        </div>
                    </div>
                    <div class="grid-body mt15">
                        <div class="data-load" v-if="load.defaultWords"><img src="/static/images/loading1.gif" class="img"/><span class="text">获取数据中...</span></div>
                        <div class="no-data no-datas" v-if="noData.defaultWords && !load.defaultWords"><span class="text">暂无数据</span></div>
                        <div class="echart-warp h305" v-if="!load.defaultWords && defaultWords != ''">
                            <cloudChart id="wordCloud" v-if="hotThemeType == 0" :dataArray="defaultWords" jump="hotTheme"></cloudChart>
                            <pieChart v-if="hotThemeType == 1 && hotThemePie != ''" id="pieEchart4" :dataArray="hotThemePie" :showLegend="false" jump="hotTheme"></pieChart>
                            <radarChart v-if="hotThemeType == 2 && hotThemePie != ''" id="radarChart" :dataArray="hotThemePie" jump="hotTheme"></radarChart>
                            <lineChart id="trendChart" :dataArray="hotThemeTrend" v-if="hotThemeType == 3 && hotThemeTrend != ''" gridBot="55"></lineChart>
                            <d3Chart id="d33Svgs" v-if="hotThemeType == 9&&dsCharts != ''" :dataArry="dsCharts" @nodeClick="openZhiyuntu" :crieSize="60" lineColor="#000" textPosition="inside"></d3chart>
                        </div>
                    </div>
                </div>
            </div>

            <!-- 发布地区 -->
            <div class="grid-father">
                <div class="grid">
                    <div class="grid-header clearfix">
                        <h2 class="title fl">发布地区</h2>
                        <div class="grid-info fl">
                            <i class="icons icons-question-circle"></i>
                            <p class="grid-tip">当前方案分析到的所有文章的发布者的所属地区</p>
                        </div>
                        <div class="fr">
                            <div class="areas-add drop-down">
                                <button class="btn btn-lightblue">{{curMapName}}<i class="icons"></i></button>
                                <city class="city-select" @cityCallback="pubCitySelect" ref="pubCity"></city>
                            </div>
                        </div>
                    </div>
                    <div class="grid-body mt15">
                        <div class="data-load" v-if="load.mapChartData"><img src="/static/images/loading1.gif" class="img"/><span class="text">获取数据中...</span></div>
                        <div class="clearfix" v-if="!load.mapChartData">
                            <div class="region mt20 fl">
                                <div class="region-header">
                                    <span class="span fl">地区</span>
                                    <span class="span fl">数量</span>
                                </div>
                                <div class="region-body">
                                    <vue-scroll :ops="ops" style="width:160px;height:246px">
                                        <div class="item cp" v-for="(item,index) of mapChartData" :key="index" @click="$refs.child.listJump(curMapName === '全国' ? 'pubProvince' : 'pubCity',item.name);">
                                            <span class="span fl ovhidden">{{item.name}}</span>
                                            <span class="span fl">{{item.value}}</span>
                                        </div>
                                    </vue-scroll>
                                </div>
                            </div>
                            <div class="echart-warp hidden h305">
                                <mapChart id="mapEchart" :dataArray="mapChartData" :areaName="curMapName" v-if="mapChartData != ''"></mapChart>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <!-- 提及地区 -->
            <div class="grid-father">
                <div class="grid">
                    <div class="grid-header clearfix">
                        <h2 class="title fl">提及地区</h2>
                        <div class="grid-info fl">
                            <i class="icons icons-question-circle"></i>
                            <p class="grid-tip">当前方案分析到的所有文章中提及到的地区</p>
                        </div>
                        <div class="fr">
                            <div class="areas-add drop-down">
                                <button class="btn btn-lightblue">{{curMapName1}}<i class="icons"></i></button>
                                <city class="city-select" @cityCallback="refCitySelect" ref="refCity"></city>
                            </div>
                        </div>
                    </div>
                    <div class="grid-body mt15">
                        <div class="data-load" v-if="load.mapChartData1"><img src='/static/images/loading1.gif' class="img"/><span class="text">获取数据中...</span></div>
                        <div class="clearfix" v-if="!load.mapChartData1">
                            <div class="region mt20 fl">
                                <div class="region-header">
                                    <span class="span ovhidden fl">地区</span>
                                    <span class="span fl">数量</span>
                                </div>
                                <div class="region-body">
                                    <vue-scroll :ops="ops" style="width:160px;height:246px">
                                        <div class="item cp" v-for="(item,index) of mapChartData1" :key="index" @click="$refs.child.listJump(curMapName1 === '全国' ? 'refProvince' : 'refCity',item.name);">
                                            <span class="span fl">{{item.name}}</span>
                                            <span class="span fl">{{item.value}}</span>
                                        </div>
                                    </vue-scroll>
                                </div>
                            </div>
                            <div class="echart-warp hidden h305">
                                <mapChart id="mapEchart1" :dataArray="mapChartData1" :areaName="curMapName1" v-if="mapChartData1 != ''"></mapChart>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </div>
        <!-- 屏蔽主题词 -->
        <Dialog ref="shieldModalFn" :callback="shieldModal" width="500">
            <div slot="mdBox">
                <textarea class="area" v-model="shieldKeywords" name="" rows="3" cols="" placeholder="请输入屏蔽词,多个用逗号隔开" @keyup="testingShieldWord();"></textarea>
            </div>
        </Dialog>
        <!-- 知云图 -->
        <Dialog ref="zhiyuntuModal" width="1200" :modalFoot="false" title="知云图">
            <div slot="mdBox">
                <d3Chart class="enlarge" bgColor="#091b31" id="d3Svg" :dataArry="dsChartsMore" @nodeClick="getEntityChild"></d3chart>
            </div>
        </Dialog>
	</div>
</template>
<script>
import city from '../../../components/city.vue';
import Dialog from '../../../components/dialog.vue';
import analysisHeader from './analysisHeader.vue';
import lineChart from '../../../components/echart/lineChart.vue';
import pieChart from '../../../components/echart/pieChart.vue';
import barPieChart from '../../../components/echart/barPieChart.vue';
import mapChart from '../../../components/echart/mapChart.vue';
import barChart from '../../../components/echart/barChart.vue';
import radarChart from '../../../components/echart/radarChart.vue';
import cloudChart from '../../../components/echart/wordCloud.vue';
import d3Chart from '../../../components/echart/d3Chart.vue';
export default {
    components:{Dialog,analysisHeader,lineChart,pieChart,barPieChart,cloudChart,mapChart,barChart,radarChart,city,d3Chart},
    data() {
        return {
            ops: {
                vuescroll: {},
                scrollPanel: {},
                rail: {
                    keepShow:true
                },
                bar: {
                    hoverStyle: true,
                    onlyShowBarOnScroll: false, //是否只有滚动的时候才显示滚动条
                    background: '#c4c4cc',
                }
            },
            planId:'',//方案ID
            mediaLevel:'',//媒体类别
            mediaPlatform:'weibo',//媒体类型
            pubArea:'全国',//地区
            startDate:'2019-07-24 10:30:00',//开始时间
            endDate:'2019-07-25 10:30:00',//结束时间
            moodLineData:'',//情感属性
			moodBarData:'',//情绪走势占比数据
			moodType:'bar',//情绪图表类别
            hotWeiboList:[],//热点微博
            weiboType:1,//微博数据类型 1是转发 2是评论 3是点赞
            activeMediaList:[],//活跃媒体
            sensitiveMediaLiat:[],//敏感信息报道媒体
            mapChartData:[],
            curMapName:'全国',//发布地区
            mapChartData1:[],
            curMapName1:'全国',//提及地区
            allDataType:'solid',//数据汇总类型
            lineChartData:[],//数据汇总
            lineForecastData:[],//七天预测数据
            informatinCount:'',//信息汇总
            userCount:'',//涉及账号数
            emotionPieData:[],//情感属性折线
            // emotionPieData2:[],//情感属性饼图
            influenceMediaLiat:[],//影响力账号
            certifyAccount:[],//账号认证
            bciData:[],//wci分布数据
            articlesTypeData:[],//文章类型
            pieColorArr:["#30d258","#e52e45","#f76a44","#ff8121","#2475fb","#1abbf0","#7b37c8","#6a4f77","#c28000","#7dbf2e","#18c391","#4b8abb","#539e79","#d216d2","#bb0000"],
            wordColors: ['#3c77ce', '#bf3a54', '#2fa130', '#ce393a', '#36accd', '#c64c65'],
            moodPieColor:["#0097e2", "#ff8121", "#e52e45", "#7737c7", "#4d4d4d", "#bd7f03", "#30d258"],
            defaultWords:[],//热门主题词词云图
            hotThemePie:[],//热门主题词饼图
            hotThemeTrend:[],//热门主题词走势
            hotThemeType:0,//控制热门主题词切换
            dsCharts:[],//非弹框展示的图谱数据
            dsChartsMore:[],//弹框知云图数据
            keywordsFinal:[],//知云词组
            shieldKeywords:'',//屏蔽词
            tuType:'pie',//控制图表类型
            provinceList:[],//地区省份选择列表
            noData:{
                'hotWeiboList':false,
                'activeMediaList':false,
                'sensitiveMediaLiat':false,
                'influenceMediaLiat':false,
                'certifyAccount':false,
                'articlesTypeData':false,
                'knowledge':false,
                'lineForecastData':false,
                'defaultWords':false
            },
            load:{
                'lineChartData':false,
                'moodLineData':false,
                'hotWeiboList':false,
                'emotionLineData':false,
                'bciData':false,
                'activeMediaList':false,
                'sensitiveMediaLiat':false,
                'influenceMediaLiat':false,
                'certifyAccount':false,
                'articlesTypeData':false,
                'defaultWords':false,
                'mapChartData':false,
                'knowledge':false,
                'lineForecastData':false,
                'mapChartData1':false
            }
        }
    },
    mounted() {
        let that = this;
		that.$nextTick(()=> {
            that.planId = that.$refs.child.planId;
            //数据加载
            that.dataAjax();
        })
    },
    created() {
		
    },
    methods: {
        // allData
        allData () {
            let that = this;
            let data = {
                sid:that.planId,
                mediaLevel:that.mediaLevel,
                isFocus:that.$refs.child.source,
                platformType:that.mediaPlatform,
                pubArea:that.pubArea,
                startDate:that.startDate,
                endDate:that.endDate,
                timeType:that.$refs.child.timeType
            }
            return data;
        },
        // 数据汇总
        dataSummary () {
            let that = this;
            let datas = that.allData();
            that.load.lineChartData = true;
            that.$api.get('monitor/analysis/total', datas, r => {
                that.$utils.returnCode(r,function(){
					that.load.lineChartData = false;
					let data = r.data;
					that.lineChartData = data.rangeData;
					if(!data.rangeData.dashes){
						that.allDataType = 'solid';
					}
                    that.informatinCount = data.count;
                    that.userCount = data.accountTotal;
				});
            })
        },
        // 获取情绪分析
		getMood (){
			let that = this;
			let datas = that.allData();
			that.load.moodLineData = true;
			that.$api.get('monitor/analysis/moods', datas, r => {
			    that.$utils.returnCode(r,function(){
			        that.load.moodLineData = false;
					let data = r.data;
					that.moodLineData = data.line;
					that.moodPieData = data.pie;
					that.moodBarData = data.columnar;
			    });
			})
		},
        // 热点微博
        hotWeibo () {
            let that = this;
            let datas = that.allData();
            datas.type = that.weiboType;
            that.load.hotWeiboList = true;
            that.$api.get('monitor/analysis/hot-article', datas, r => {
                that.$utils.returnCode(r,function(){
                    that.load.hotWeiboList = false;
                    let data = r.data;
                    that.hotWeiboList = data;
                    if(data.length <= 0){
                        that.noData.hotWeiboList = true;
                    }else{
                        that.noData.hotWeiboList = false;
                    }
                });
            })
        },
        // 微博选择
        selectWeiboType (type) {
            this.weiboType = type;
            this.hotWeibo();
        },
        // 七天预测
        get7DaysForecast (){
            let that = this;
            let data = {
                sid:that.planId,
                mediaLevel:that.mediaLevel,
                isFocus:that.$refs.child.source,
                platformType:that.mediaPlatform,
                pubArea:that.pubArea,
                timeType:that.$refs.child.timeType
            }
            that.load.lineForecastData = true;
            that.$api.get('monitor/analysis/data-forecast', data, r => {
                that.$utils.returnCode(r,function(){
                    that.load.lineForecastData = false;
                    that.lineForecastData = r.data;
                });
            })
        },
        // 情感属性
        emotionalAttributes () {
            let that = this;
            let datas = that.allData();
            that.load.emotionLineData = true;
            that.$api.get('monitor/analysis/emotion', datas, r => {
                that.$utils.returnCode(r,function(){
                    that.load.emotionLineData = false;
                    let data = r.data;
                    that.emotionLineData = {
                        "dataName":["正面","中性","负面"],
                        "正面":data.line.positive.data,
                        "中性":data.line.neutral.data,
                        "负面":data.line.negative.data,
                        "datetime":data.line.positive.time
                    }
                    that.emotionPieData = data.pie;
                });
            })
        },
        // 活跃媒体
        activeMedia () {
            let that = this;
            let datas = that.allData();
            that.load.activeMediaList = true;
            that.$api.get('monitor/analysis/active-media', datas, r => {
                that.$utils.returnCode(r,function(){
                    that.load.activeMediaList = false;
                    let data = r.data;
                    that.activeMediaList = data;
                    if(data.length <= 0){
                        that.noData.activeMediaList = true;
                    }else{
                        that.noData.activeMediaList = false;
                    }
                });
            })
        },
        // 敏感信息报道账号
        sensitiveMedia () {
            let that = this;
            let datas = that.allData();
            that.load.sensitiveMediaLiat = true;
            that.$api.get('monitor/analysis/sensitive-media', datas, r => {
                that.$utils.returnCode(r,function(){
                    that.load.sensitiveMediaLiat = false;
                    let data = r.data;
                    that.sensitiveMediaLiat = data;
                    if(data.length <= 0){
                        that.noData.sensitiveMediaLiat = true;
                    }else{
                        that.noData.sensitiveMediaLiat = false;
                    }
                });
            })
        },
        // 账号认证
        certifyAccountFn () {
            let that = this;
            let datas = that.allData();
            that.load.certifyAccount = true;
            that.$api.get('monitor/analysis/certify-account', datas, r => {
                that.$utils.returnCode(r,function(){
                    that.load.certifyAccount = false;
                    let data = r.data;
                    that.certifyAccount = data;
                    if(data.length <= 0){
                        that.noData.certifyAccount = true;
                    }else{
                        that.noData.certifyAccount = false;
                    }
                });
            })
        },
        // 影响力账号
        influenceMedia () {
            let that = this;
            let datas = that.allData();
            that.load.influenceMediaLiat = true;
            that.$api.get('/monitor/analysis/influence-account', datas, r => {
                that.$utils.returnCode(r,function(){
                    that.load.influenceMediaLiat = false;
                    let data = r.data;
                    that.influenceMediaLiat = data;
                    if(data.length <= 0){
                        that.noData.influenceMediaLiat = true;
                    }else{
                        that.noData.influenceMediaLiat = false;
                    }
                });
            })
        },
        // BCI分布
        getBci () {
            let that = this;
            let datas = that.allData();
            that.load.bciData = true;
            that.$api.get('monitor/analysis/bci', datas, r => {
                that.$utils.returnCode(r,function(){
                    that.load.bciData = false;
                    let data = r.data;
                    let newData =  {
                        "datetime":data.keys,
                        "dataName":['BCI分布'],
                        "data":[
                            data.values
                        ],
                    };
                    that.bciData = newData;
                });
            })
        },
        // 文章类型
        articlesTypes () {
            let that = this;
            let datas = that.allData();
            that.load.articlesTypeData = true;
            that.$api.get('monitor/analysis/article-type', datas, r => {
                that.$utils.returnCode(r,function(){
                    that.load.articlesTypeData = false;
                    let data = r.data;
                    that.articlesTypeData = data;
                    if(data.length <= 0){
                        that.noData.articlesTypeData = true;
                    }else{
                        that.noData.articlesTypeData = false;
                    }
                });
            })
        },
        // 热门主题词
        hotTheme () {
            let that = this;
            let datas = that.allData();
            that.load.defaultWords = true;
            that.$api.get('monitor/analysis/hot-theme', datas, r => {
                that.$utils.returnCode(r,function(){
                    that.load.defaultWords = false;
                    let data = r.data;
                    that.defaultWords = data;
                    if(data.length <= 0){
                        that.noData.defaultWords = true;
                    }else{
                        that.noData.defaultWords = false;
                    }
                    that.hotThemePie = data.slice(0,19);
                    that.getLineHotword(data.slice(0,10));
                });
            })
        },
        // 热词走势
        getLineHotword (data){
            let that = this;
            let datas = that.allData();
            let keywords = data.map(v=>v.name);
            datas.keywordsList = JSON.stringify(keywords);
            that.$api.get('monitor/analysis/hot-theme-trend', datas, r => {
                that.$utils.returnCode(r,function(){
                    let data = r.data;
                    that.hotThemeTrend = data;
                });
            })
        },
        //热词知云图数据
        getZhiHotword (){
            let that = this;
            let data = that.allData();
            that.load.knowledge = true;
            that.$api.get('monitor/analysis/notional-words',data,r =>{
                that.$utils.returnCode(r,function(){
                    let data = r.data;
                    that.load.knowledge = false;
                    if(data.length <= 0){
                        that.noData.knowledge = true;
                        return;
                    }else{
                        that.noData.knowledge = false;
                    }
                    that.dsCharts = that.$utils.makeChartData(data);
                })
            },r =>{
                that.load.knowledge = false;
                that.noData.knowledge = true;
            })
        },
        // 打开知云图
        openZhiyuntu (){
            this.dsChartsMore = [{...this.dsCharts}][0];
            this.$refs.zhiyuntuModal.showMaskFun();
        },
        getEntityChild (name,id,level){
            let that = this;
            that.$api.get('monitor/analysis/knowledge-node',{sid:that.planId,id:id,name:name,level:level},r =>{
                that.$utils.returnCode(r,function(){
                    let nodes = that.dsChartsMore.nodes.concat(that.$utils.makeChartData(r.data).nodes);
                    let links = that.dsChartsMore.links.concat(that.$utils.makeChartData(r.data).links);
                    that.dsChartsMore = {
                        nodes:nodes,
                        links:links
                    }
                })
            })
        },
        // 热门主题词切换
        hotThemeTab (type) {
            this.hotThemeType = type;
        },
        // 屏蔽主题词
        shieldThemeWord () {
            let that = this;
            that.$refs.shieldModalFn.showMaskFun();
        },
        // 确定屏蔽词
        shieldModal () {
            let that = this;
            let datas = that.allData();
            datas.words = that.shieldKeywords;
            let shieldKeywords = that.shieldKeywords;//获取输入的屏蔽词
            that.$refs.shieldModalFn.closeMask();
            that.$parent.loadModal(true,'正在获取数据...');
            that.$parent.showLoad = false;
            that.$api.get('monitor/analysis/shield-theme', datas, r => {
                that.$utils.returnCode(r,function(){
                    let data = r.data;
                    that.defaultWords = data;//获取屏蔽词数据
                    that.hotThemePie = data.slice(0,19);
                    that.$refs.shieldModalFn.closeMask();
                });
            })
        },
        // 屏蔽词校验
        testingShieldWord () {
            let that = this;
            let shieldKeywords = that.shieldKeywords;
            let shieldKeywords1 = '';
            //中文逗号转英文
            shieldKeywords1 = shieldKeywords.replace(/，/g,",");
            that.shieldKeywords = shieldKeywords1;
            // 获取第一个字符
            let frist = that.shieldKeywords[0] 
            //去除连续,
            let pattern = /\,{2}/;//去除连续正则
            let len = (shieldKeywords.match(/,/g)||[]).length;
            if(len >= 10 || pattern.test(that.shieldKeywords) || frist === ','){//判断分析词个数和连续,
                shieldKeywords1 = shieldKeywords.substr(0, shieldKeywords.length - 1); 
                that.shieldKeywords = shieldKeywords1;
            }
        },
        // 发布地区选择地区
        pubCitySelect (name){
            this.curMapName = name;
            this.publishingArea(0);
        },
        // 提及地区选择
        refCitySelect(name){
            this.curMapName1 = name;
            this.publishingArea(1);
        },
        // 发布地区
        publishingArea (type) {
            let that = this;
            // let datas = that.allData();
            let url = '';
            let pubArea = '';
            if(type === 0){//发布地去
                url = 'monitor/analysis/pub-area';
                pubArea = that.curMapName;
                that.load.mapChartData = true;
            }else if(type === 1){//提及地区
                url = 'monitor/analysis/ref-area';
                pubArea = that.curMapName1;
                that.load.mapChartData1 = true;
            }
            let datas = {
                sid:that.planId,
            	mediaLevel:that.mediaLevel,
            	platformType:that.mediaPlatform,
            	selfPubArea:pubArea,
            	startDate:that.startDate,
            	endDate:that.endDate,
            	timeType:that.$refs.child.timeType,
            	isFocus:that.$refs.child.source
            };
            that.$api.get(url, datas, r => {
                that.$utils.returnCode(r,function(){
                    let data = r.data;
                    if(type === 0){//发布地去
                        that.mapChartData = data;
                        that.load.mapChartData = false;
                    }else if(type === 1){//提及地区
                        that.mapChartData1 = data.data; 
                        that.load.mapChartData1 = false;                
                    }
                });
            })
        },
		dataAjax(){
            let that = this;
            //数据汇总
            that.dataSummary();
            //情绪
			that.getMood();
            //热点事件
            that.hotWeibo();
             // 7天预测
            that.get7DaysForecast();
            // 知云图
            that.getZhiHotword();
            // 情感属性
            that.emotionalAttributes ();
            // 活跃媒体
            that.activeMedia();
            // 敏感信息报道账号
            that.sensitiveMedia();
            //账号认证
            that.certifyAccountFn();
            // 影响力账号
            that.influenceMedia();
            //bci分布
            that.getBci();
            // 文章类型
            that.articlesTypes();
            // 热门主题词
            that.hotTheme();
            //发布地去
            that.publishingArea(0);
            //提及地去
            that.publishingArea(1);
        },
        // 情感属性图表切换
        emotionEchartTab (type) {
            this.tuType = type;
        },
        wordClickHandler(name, value, vm) {
            // console.log('wordClickHandler', name, value, vm);
        },
        //地图点击
        fatherMethod(name,id){
            let type = '';
            if(id=="mapEchart"){
                this.curMapName = name;
                type = 0;
            }else{
                this.curMapName1 = name;
                type = 1;
            }
            this.publishingArea(type);
        },
    }
}
</script>



// WEBPACK FOOTER //
// src/page/yuqingFenxi/propagationAnalysis/wbAnalysis.vue